import { render } from "./PaymentCompletionAwaiter.vue?vue&type=template&id=6ef25a20&scoped=true"
import script from "./PaymentCompletionAwaiter.vue?vue&type=script&lang=js"
export * from "./PaymentCompletionAwaiter.vue?vue&type=script&lang=js"

import "./PaymentCompletionAwaiter.vue?vue&type=style&index=0&id=6ef25a20&lang=scss&scoped=true"

import exportComponent from "/Users/mac/Documents/Tranzak/Frontend/tzpay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef25a20"]])

export default __exports__